import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./TabActionBar.module.css";

/**
 * Two-tab (or multi-tab) switcher used at the top of the Digital Delivery page.
 * The active tab renders white with dark blue text; inactive tabs render
 * dark blue with white text.
 *
 * @example
 * <TabActionBar
 *   tabs={[
 *     { label: "Current", value: "current" },
 *     { label: "History", value: "history" },
 *   ]}
 *   activeTab={activeTab}
 *   onChange={setActiveTab}
 * />
 */
export function TabActionBar({ tabs, activeTab, onChange, className }) {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.tabRow}>
        {tabs.map(({ label, value }) => {
          const isActive = value === activeTab;

          return (
            <button
              key={value}
              type="button"
              className={classNames(styles.tab, {
                [styles.active]: isActive,
              })}
              aria-pressed={isActive}
              onClick={() => onChange(value)}
              data-testid={label}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

TabActionBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};